import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { linkToIframe } from '@/utiils';
import {  WP_URL } from '@/config';

function LogoutPage() {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('token');
        linkToIframe('', { isIframeUrl: `${WP_URL}` });
    }, [navigate]);

    return null;
}

export default LogoutPage;